<profile-card class="grow" title="Changer de mot de passe">
  <change-password-form></change-password-form>
</profile-card>
